import React from "react";
import { Link } from "react-router-dom";
import timelapsed from "timelapsed";
import { toast } from "react-toastify";

function LinksTable({ links }) {
  const handleCopy = (slug) => {
    navigator.clipboard
      .writeText(`https://lipia-online.vercel.app/link/${slug}`)
      .then(() => {
        toast.success("key copyed to clipboard");
      })
      .catch((err) => {
        alert("copying failed");
      });
  };
  return (
    <div className="relative overflow-x-auto shadow-md sm:rounded-lg mt-12">
      <table className="w-full text-sm text-left text-gray-500 ">
        <thead className="text-xs text-gray-700 uppercase bg-yellow-100 ">
          <tr>
            <th scope="col" className="px-6 py-3">
              Title
            </th>
            <th scope="col" className="px-6 py-3">
              App
            </th>
            <th scope="col" className="px-6 py-3">
              status
            </th>
            <th scope="col" className="px-6 py-3">
              Created
            </th>
            <th scope="col" className="px-6 py-3">
              Action
            </th>
          </tr>
        </thead>
        <tbody>
          {links.length < 1 ? (
            <tr className="bg-yellow-50 border-b hover:bg-yellow-50 ">
              <th
                scope="row"
                className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap"
              >
                No Links
              </th>
            </tr>
          ) : (
            links.map((item) => (
              <tr
                className="bg-yellow-50 border-b hover:bg-yellow-50"
                key={item._id}
              >
                <th
                  scope="row"
                  className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap "
                >
                  {item.title}
                </th>
                <td className="px-6 py-4">{item.app.name}</td>
                <td className="px-6 py-4">{item.status}</td>
                <td className="px-6 py-4">
                  {timelapsed.fromDateString(item.createdAt)}
                </td>
                <td className="flex items-center px-6 py-4 space-x-3">
                  <div className="flex md:order-2">
                    <button
                      onClick={() => handleCopy(item.slug)}
                      className="text-yellow-900 bg-yellow-400 opacity-80 hover:bg-yellow-300 focus:ring-3 focus:outline-none focus:ring-yellow-800 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center"
                    >
                      Copy Payment Link
                    </button>
                  </div>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}

export default LinksTable;
